import { MDBContainer, MDBBtn } from "mdbreact";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../../redux/actions";
import { Beat } from "../../../redux/reducers/spinner";

export default function RejectOrder({ id }) {
  // let user = JSON.parse(localStorage.getItem("user"));
  // let teamId = JSON.parse(localStorage.getItem("teamId"));
  // const company_id = user?.data?.groups[teamId]?.company_id;

  const dispatch = useDispatch();

  const rejecting = useSelector((state) => state.admin.rejecting);

  function reject() {
    dispatch(adminActions.rejectOrder({ courier_order_id: id }));
  }

  return (
    <div>
      <MDBContainer>
        <MDBBtn color='primary' onClick={() => reject()}>
          {rejecting === true ? <Beat loading={true} /> : "Reject Order"}
        </MDBBtn>
      </MDBContainer>
    </div>
  );
}
